import React, { Component } from 'react';
import './PopupMenu.css';
import ParameterErrors from '../errors/ParameterErrors';
import getAbsolute from '../ui_core/getAbsolute';
import Rect from '../geometry/Rect';
import Once from '../core/Once';
import EventNormalizer from '../core/EventNormalizer';
import getViewportDimensions from '../ui_core/getViewportDimensions';
import EdgeLocation from '../ui_core/EdgeLocation';
const {throwNotProvided}=ParameterErrors;
export default class PopupMenu extends Component {
	constructor(props){
		super(props)
		const {className, edgeLocation, onHide}=props;
		this._callbackOnHide = onHide;
		this._edgeLocation=edgeLocation;
		this._className=className;
		this._inner = React.createRef();
		this._elementRef = React.createRef();
		this.show = this.show.bind(this);
		this.hide = this.hide.bind(this);
		this.showInExistingPosition = this.showInExistingPosition.bind(this);
		this._repositionVerticallySoOnPage = this._repositionVerticallySoOnPage.bind(this);
		this._repositionHorizontallySoOnPage = this._repositionHorizontallySoOnPage.bind(this);
		this._startWatchingForClickOff = this._startWatchingForClickOff.bind(this);
		this._startWatchingMouseForLeave = this._startWatchingMouseForLeave.bind(this);
		this._checkMouseWithinBoundsAndAct = this._checkMouseWithinBoundsAndAct.bind(this);
		this._doResposition= this._doResposition.bind(this);
		this._getCurrentRect= this._getCurrentRect.bind(this);
		this._mouseMove = this._mouseMove.bind(this);
		this._mouseDown = this._mouseDown.bind(this);
		this._touchStart = this._touchStart.bind(this);
		this._setVisible = this._setVisible.bind(this);
		this._setLeft= this._setLeft.bind(this);
		this._setTop= this._setTop.bind(this);
		this._setRelocated= this._setRelocated.bind(this);
		this._showing = false;
		this._checkMouseWithinBoundsAndActOnce = new Once(this._checkMouseWithinBoundsAndAct);
		this.state = {relocated:false};
	}
	show({position, getMouseInSourceBounds, untilClickOff}){
		setTimeout(()=>{
			this._showing = true;
			this._getMouseInSourceBounds=getMouseInSourceBounds;
			this._dueReposition=true;
			this._setLeft(position?position[0]:0);
			this._setTop(position?position[1]:0);
			setTimeout(this._doResposition, 0);
			this._setVisible(true);
			this._setRelocated(true);
			setTimeout(untilClickOff?this._startWatchingForClickOff:this._startWatchingMouseForLeave,0);
		}, 0);
	}
	showInExistingPosition(){
		setTimeout(()=>{
			this._showing = true;
			this._setVisible(true);
			this._setRelocated(true);
		}, 0);}
	get element(){
		return this._elementRef.current;
	}
	get innerElement(){
		return this._inner.current;
	}
	_setLeft(left){
		const element = this._elementRef.current;
		element.style.left = `${left}px`;
	}
	_setTop(top){
		const element = this._elementRef.current;
		element.style.top = `${top}px`;
	}
	_setVisible(visible){
		const element = this._elementRef.current;
		if(visible)
			element.classList.add('visible');
		else 
			element.classList.remove('visible');
	}
	_setRelocated(relocated){
		const element = this._elementRef.current;
		if(relocated){
			element.classList.add('relocated');
			element.classList.remove('did-not-relocate');
			return;
		}
		element.classList.add('did-not-relocate');
		element.classList.remove('relocated');
	}
	_startWatchingMouseForLeave(){
		document.documentElement.addEventListener('mousemove', this._mouseMove);
		document.documentElement.addEventListener('touchstart', this._touchStart);
		this._currentRect = this._getCurrentRect();
	}
	_startWatchingForClickOff(){
		document.documentElement.addEventListener('mousedown', this._mouseDown);
		document.documentElement.addEventListener('touchstart', this._touchStart);
		this._currentRect = this._getCurrentRect();
	}
	_getCurrentRect(){
		const inner = this._inner.current;
		const absolutePosition = getAbsolute(inner);
		return new Rect({x:absolutePosition.left, y:absolutePosition.top, width:inner.offsetWidth, height:inner.offsetHeight});
	}
	_mouseMove(e){
		this._checkMouseWithinBoundsAndAct(e);
	}
	_mouseDown(e){
		EventNormalizer.addFriendlyXYToMouse(e);
		this._checkMouseWithinBoundsAndActOnce.trigger(e);
	}
	_touchStart(e){
		EventNormalizer.addFriendlyXYToTouch(e);
		this._checkMouseWithinBoundsAndActOnce.trigger(e);
	}
	_checkMouseWithinBoundsAndAct(e){
		const x = e.x;
		const y = e.y;
		const point = [x,y];
		if(this._getMouseInSourceBounds&&this._getMouseInSourceBounds(point))return;
		if(!this._currentRect.containsPoint(point))
			this.hide();
	}
	hide(){
		if(!this._showing)return;
		this._showing = false;
		this._setVisible(false);
		document.documentElement.removeEventListener('mousemove', this._mouseMove);
		document.documentElement.removeEventListener('mousedown', this._mouseDown);
		document.documentElement.removeEventListener('touchstart', this._touchStart);
		this._callbackOnHide&&this._callbackOnHide();
	}
	_doResposition(){
		const innerElement = this._inner.current;
		const viewportDimensions = getViewportDimensions();
		const currentRect = this._getCurrentRect();
		const relocatedVertically = this._repositionVerticallySoOnPage(currentRect, viewportDimensions);
		const relocatedHorizontally = this._repositionHorizontallySoOnPage(currentRect, viewportDimensions);
		const relocated = relocatedVertically||relocatedHorizontally;
		this._setRelocated(relocated);
	}
	_repositionVerticallySoOnPage(currentRect, viewportDimensions){
		const height = currentRect.height;
		const fromTopOfViewPort = currentRect.y;
		const fromBottomOfViewPort = viewportDimensions[1]-(fromTopOfViewPort+height);
		let newTop;
		if(fromTopOfViewPort<0){
			newTop=0;
			if(fromTopOfViewPort+fromBottomOfViewPort<0){
				newTop = -(height-viewportDimensions[1])/2;
			}
		}
		else if (fromBottomOfViewPort<0){
			 newTop = viewportDimensions[1]-height;
			if(fromTopOfViewPort+fromBottomOfViewPort<0){
				newTop = -(height-viewportDimensions[1])/2;
			}
		}
		else return false;
		let correctionForEdgeLocation=0;
		switch(this._edgeLocation){
			case EdgeLocation.TOP_LEFT:
			case EdgeLocation.TOP_RIGHT:
			case EdgeLocation.TOP_CENTER:
				break;
			case EdgeLocation.MIDDLE_RIGHT:
			case EdgeLocation.MIDDLE_LEFT:
				correctionForEdgeLocation=height/2;
				break;
			case EdgeLocation.BOTTOM_RIGHT:
			case EdgeLocation.BOTTOM_LEFT:
			case EdgeLocation.BOTTOM_CENTER:
				correctionForEdgeLocation=height;
				break;
		}
		newTop+= correctionForEdgeLocation;
		this._setTop(newTop);
		return true;
	}
	_repositionHorizontallySoOnPage(currentRect, viewportDimensions){	
		const width = currentRect.width;
		const fromLeftOfViewPort = currentRect.x;
		const fromRightOfViewPort = viewportDimensions[0]-(fromLeftOfViewPort+width);
		let newLeft;
		if(fromLeftOfViewPort<0){
			newLeft=0;
			if(fromLeftOfViewPort+fromRightOfViewPort<0){
				newLeft = -(width-viewportDimensions[0])/2;
			}
		}
		else if (fromRightOfViewPort<0){
			newLeft = viewportDimensions[0]-width;
			if(fromLeftOfViewPort+fromRightOfViewPort<0){
				newLeft = -(width-viewportDimensions[0])/2;
			}
		}
		else return false;
		let correctionForEdgeLocation=0;
		switch(this._edgeLocation){
			case EdgeLocation.TOP_LEFT:
			case  EdgeLocation.BOTTOM_LEFT:
			case EdgeLocation.MIDDLE_LEFT:
				break;
			case EdgeLocation.TOP_CENTER:
			case EdgeLocation.BOTTOM_CENTER:
				correctionForEdgeLocation=width/2;
				break;
			case EdgeLocation.TOP_RIGHT:
			case EdgeLocation.MIDDLE_RIGHT:
			case EdgeLocation.BOTTOM_RIGHT:
				correctionForEdgeLocation=width;
				break;
		}
		newLeft+=correctionForEdgeLocation;
		this._setLeft(newLeft);
		return true;
	}
	render() {
		let className = `popup-menu`; 
		const innerClassName=`inner ${this._edgeLocation} ${this._className}`;
		return (<div className={className} ref={this._elementRef}>
					<div className={innerClassName} ref={this._inner}>
						{this.props.children}
					</div>
				</div>)
	}
}
